/**
 * @fileoverview Google Analytics 4 event tracking handler for manufacturer brand landing pages.
 * Manages tracking of featured brand views and clicks using RxJS observables.
 * @module googleAnalytics4EventsHandler
 */
import { store } from "@redux/store";
import { googleAnalytics4Event } from "features/googleAnalytics4";
import { bodyClick$, onPageComplete$ } from "pages/manufacturerBrandLanding/redux/observables";
import { filter, map } from "rxjs";
import determineReferrerSourceManufacturerPages from "utils/referrerSource";
import getBrandPageUrl from "../../services/manufacturerBrandCardService";

const totalBrands = document.querySelectorAll('[data-brand-card]').length;

/**
 * Retrieves the closest manufacturer card element from the event target.
 * @function getManufacturerCard
 * @param {Event} event - The DOM event object
 * @returns {Element|null} The manufacturer card element or null if not found
 */
const getManufacturerCard = (event) => event.target.closest('[data-brand-card]');

/**
 * Triggers a Google Analytics 4 event when featured brands are loaded on the page.
 * Dispatches a 'featured_brands_view' event with page type and source URL.
 * @function triggerFeaturedBrandLoad
 * @returns {void}
 */
const triggerFeaturedBrandLoad = () => {

  const customProperties = {
    pageType: 'featured_brands_directory',
    sourceUrl: determineReferrerSourceManufacturerPages(document.referrer),
  };

  store.dispatch(googleAnalytics4Event({ eventName: 'featured_brands_view', customProperties }));
};

onPageComplete$.subscribe(triggerFeaturedBrandLoad);

/**
 * Triggers a Google Analytics 4 event when a featured brand is clicked.
 * Dispatches a 'featured_brands_events' event with click target information.
 * @function triggerOnClickFeaturedBrand
 * @returns {void}
 * @todo Add position, destination, and total_brands_rendered properties
 */
const triggerOnClickFeaturedBrand = (card) => {
  const dataset = card.dataset;
  const parsedIndex = parseInt(dataset.index, 10) || 0;
  const customProperties = {
    click_target: 'featured_brands_clicked',
    pageType: 'featured_brands_directory',
    position: parsedIndex + 1,
    destination: getBrandPageUrl(card),
    click_target1: totalBrands
  };

  store.dispatch(googleAnalytics4Event({ eventName: 'featured_brands_events', customProperties, skipDebounce: true }));
};

bodyClick$.pipe(map(getManufacturerCard), filter(Boolean)).subscribe(triggerOnClickFeaturedBrand);